import React, { useState } from "react";
import eventDispatch from "./utils/eventDispatch";
import {
    TOGGLE_LIVESTREAM,
} from "./utils/events";

export default ({ panel, active }) => {

    const toggleModal = () => {
        eventDispatch(TOGGLE_LIVESTREAM, { panel, active });
    };

    return (
        <span className="panel__booking">
            <button onClick={toggleModal} className="button primary">
                <span className="text">Watch now</span>
            </button>
        </span>
    );
};
